import React, { Component } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import "aos/dist/aos.css";
import { useNavigate } from "react-router-dom";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import CtBtn from "../Components/CustomTool/CtBtn";
import CtTxt from "../Components/CustomTool/CtTxt";
import CtMultiLineText from "../Components/CustomTool/CtMultiLineText";
import "react-checkbox-tree/lib/react-checkbox-tree.css";
import AlertResponsiveDialog from "../Components/CustomTool/AlertResponsiveDialog";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import {
  applyTrimOnObjectValues,
  csvFileName,
  getRowOfRT,
  setKeyboardShortcuts,
} from "../SystemUtility/SystemUtility";
import {
  mapSetUserPrivileges_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import { connect } from "react-redux";
import { withRouter } from "../HOC/withRouter";
import CtART from "./CustomTool/ResponsiveTable";
import { fetchContractType } from "./API";

class AMCContractType extends Component {
  state = {
    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "SR No",
        size: 80,
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_typeofamccontract",
        header: "Types Of AMC Contracts",
      },
      {
        accessorKey: "vac_termsconditionline1",
        header: "Terms & Condition Line 1",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_termsconditionline2",
        header: "Terms & Condition Line 2",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_termsconditionline3",
        header: "Terms & Condition Line 3",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
      {
        accessorKey: "vac_termsconditionline4",
        header: "Terms & Condition Line 4",
        enableColumnActions: false,
        // enableResizing: false,
        enableSorting: false,
        enableColumnDragging: false,
      },
    ],

    rows: [
      {
        bint_srno: 1,
        vac_typeofamccontract: "AMC Contract Type 1",
        vac_termsconditionline1: "Term 1",
        vac_termsconditionline2: "Term 2",
        vac_termsconditionline3: "Term 3",
        vac_termsconditionline4: "Term 4",
      },
    ],
    formData: {
      bint_srno: 0,
      txtTypeOfAmcContract: "",
      txtTermsConditionLine1: "",
      txtTermsConditionLine2: "",
      txtTermsConditionLine3: "",
      txtTermsConditionLine4: "",
    },
    dataLoadStatus: true,
    ARD: null,
    rowsCount: 0,
    rowsPerPage: 50,
  };

  //#region Component
  componentDidMount() {
    localStorage.setItem("Heading", "AMC Contract Type");
    this.props.verifyUserID(this.getInfo, this.props.setUserPrivileges);
    this.ShortCut();
  }

  componentWillUnmount() {
    this.removeShortCut();
  }

  //#endregion Component

  //#region Handle

  ShortCut = () => {
    this.removeShortCut = setKeyboardShortcuts(
      this.saveContractType,
      this.clearInfo,
      () => {
        this.DeleteData(
          this.state.formData.bint_srno,
          this.state.formData.txtTypeOfAmcContract,
        );
      },
    );
  };

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleARDonActionClick_Edit = (rtRow) => {
    const row = getRowOfRT(rtRow, [
      "bint_srno",
      "vac_typeofamccontract",
      "vac_termsconditionline1",
      "vac_termsconditionline2",
      "vac_termsconditionline3",
      "vac_termsconditionline4",
    ]);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno: row.bint_srno,
        txtTypeOfAmcContract: row.vac_typeofamccontract,
        txtTermsConditionLine1: row.vac_termsconditionline1,
        txtTermsConditionLine2: row.vac_termsconditionline2,
        txtTermsConditionLine3: row.vac_termsconditionline3,
        txtTermsConditionLine4: row.vac_termsconditionline4,
      },
    });
    document.getElementById("txtTypeOfAmcContract").focus();
  };

  handleARDonActionClick_Delete = (rtRow) => {
    const row = getRowOfRT(rtRow, ["bint_srno", "vac_typeofamccontract"]);
    this.DeleteData(row.bint_srno, row.vac_typeofamccontract);
  };

  //#endregion Handle

  //#region function

  getInfo = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "ListContractType",
    };
    fetchContractType(reqData)
      .then((res) => {
        this.props.closeUpdateProcessing();
        let rows = res.data.ContractTypeList || [],
          rowsCount = rows.length;

        this.setState({
          rowsCount,
          rows,
        });
      })
      .catch((error) => {
        console.log("Unknown error occurred in onFormLoad.", error);
      });
    document.getElementById("txtTypeOfAmcContract").focus();
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno: 0,
          txtTypeOfAmcContract: "",
          txtTermsConditionLine1: "",
          txtTermsConditionLine2: "",
          txtTermsConditionLine3: "",
          txtTermsConditionLine4: "",
        },
      },
      () => {
        document.getElementById("txtTypeOfAmcContract").focus();
      },
    );
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  validationContractType = () => {
    let result = false;
    if (this.state.formData.txtTypeOfAmcContract.length <= 0) {
      this.props.toastErrorMsg(
        "Enter Types Of AMC Contracts",
        "txtTypeOfAmcContract",
      );
    } else {
      result = true;
    }
    return result;
  };

  saveContractType = () => {
    this.trimFormData(() => {
      if (this.validationContractType()) {
        this.props.notifyProcessing();
        const reqData = {
          Op: "SaveContractType",
          bint_srno: this.state.formData.bint_srno,
          vac_typeofamccontract: this.state.formData.txtTypeOfAmcContract,
          vac_termsconditionline1: this.state.formData.txtTermsConditionLine1,
          vac_termsconditionline2: this.state.formData.txtTermsConditionLine2,
          vac_termsconditionline3: this.state.formData.txtTermsConditionLine3,
          vac_termsconditionline4: this.state.formData.txtTermsConditionLine4,
        };
        fetchContractType(reqData)
          .then((res) => {
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let rows = [],
                rowsCount = rows.length;
              if (
                res.data.ContractTypeList &&
                res.data.ContractTypeList.length > 0
              ) {
                rows = res.data.ContractTypeList;
                rowsCount = rows.length;
              }
              this.setState(
                {
                  rows,
                  rowsCount,
                },
                () => {
                  this.clearInfo();
                },
              );
            }
          })
          .catch((error) => {
            console.log(
              "Unknown error occurred in Save AMC Contract Type.",
              error,
            );
          });
      }
    });
  };

  DeleteData = (bint_srno, vac_typeofamccontract) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={`Do you want to Delete : ${vac_typeofamccontract} ?`}
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteContractType(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteContractType = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteContractType",
      bint_srno: bint_srno,
    };
    fetchContractType(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (
            res.data.ContractTypeList &&
            res.data.ContractTypeList.length > 0
          ) {
            rows = res.data.ContractTypeList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.clearInfo();
            },
          );
        }
      })
      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete AMC Contract Type. " + error,
        );
      });
    return false;
  };

  //#endregion function

  render() {
    return (
      <form>
        <Grid container direction="row" justifyContent="flex-end">
          <Grid item>
            <Grid container spacing={2} justifyContent="flex-end">
              <Grid item>
                <CtBtn
                  className="secondary-button"
                  label="Save"
                  iconName="save"
                  onClick={this.saveContractType}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="New"
                  className="new-button"
                  iconName="new"
                  onClick={this.clearInfo}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  className="delete-button"
                  iconName="delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtTypeOfAmcContract,
                    );
                  }}
                  disabled={this.state.formData.bint_srno > 0 ? false : true}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxt
              id="txtTypeOfAmcContract"
              label="Types Of AMC Contracts*"
              value={this.state.formData.txtTypeOfAmcContract}
              handleOnChange={this.handleOnChange}
              width={260}
              maxLength={100}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtTermsConditionLine1"}
            />
          </Grid>
        </Grid>

        <Grid container direction="row" spacing={2} marginTop={0}>
          <Grid item>
            <CtMultiLineText
              id="txtTermsConditionLine1"
              label="Terms & Condition Line 1"
              value={this.state.formData.txtTermsConditionLine1}
              handleOnChange={this.handleOnChange}
              width={350}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtTermsConditionLine2"}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtTermsConditionLine2"
              label="Terms & Condition Line 2"
              value={this.state.formData.txtTermsConditionLine2}
              handleOnChange={this.handleOnChange}
              width={350}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtTermsConditionLine3"}
            />
          </Grid>
        </Grid>
        <Grid container direction="row" spacing={2} marginTop={0}>
          <Grid item>
            <CtMultiLineText
              id="txtTermsConditionLine3"
              label="Terms & Condition Line 3"
              value={this.state.formData.txtTermsConditionLine3}
              handleOnChange={this.handleOnChange}
              width={350}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"txtTermsConditionLine4"}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtTermsConditionLine4"
              label="Terms & Condition Line 4"
              value={this.state.formData.txtTermsConditionLine4}
              handleOnChange={this.handleOnChange}
              width={350}
              maxLength={1000}
              onKeyDown={this.props.onKeyDown}
              defaultAction={this.saveContractType}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={1}
          marginTop={1}
        >
          <Grid item className="maintable">
            <CtART
              rowsdata={this.state.rows}
              columnsdata={this.state.columnsdata}
              rowsPerPage={this.state.rowsPerPage}
              tblmaxHeight={500}
              csvFileName={csvFileName("AMC Contract Type")}
              rowIconAction={[
                {
                  label: "Edit",
                  onClick: this.handleARDonActionClick_Edit,
                  icon: "Edit",
                  className: "secondary-button",
                },
                {
                  label: "Delete",
                  onClick: this.handleARDonActionClick_Delete,
                  icon: "delete",
                  className: "delete-button",
                },
              ]}
              showColumnFilters={false}
              actionColSize={80}
              density={"compact"}
              hideColIdList={[""]}
            />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

function WithNavigate(props) {
  let navigate = useNavigate();
  return <AMCContractType {...props} navigate={navigate} />;
}
export default connect(
  mapStatetoProps,
  mapSetUserPrivileges_ToProps,
)(HoCtToastContainer(HOCVerifyIsUser(withRouter(WithNavigate))));
